var videoLibrary={};
var categoryIndex=0;
videoLibrary.categories={};
videoLibrary.categories.title='<span>¿SABÍAS QUE UNA APLICACIÓN ADECUADA PUEDE</span> <h2>MAXIMIZAR LOS RESULTADOS?</h2>';
videoLibrary.categories.data=[];

// Category 1
//Category page related data
videoLibrary.categories.data[categoryIndex]={};
videoLibrary.categories.data[categoryIndex].title="LIMPIADORES & TÓNICOS";
videoLibrary.categories.data[categoryIndex].coverImage="https://cdn.shopify.com/s/files/1/1131/8002/files/CLEANSERS_TONERS_Category_Cover.png?v=1678178328";
videoLibrary.categories.data[categoryIndex].description="Nuestras fórmulas de limpieza y tonificación, limpian la piel sin alterar el natural equilibrio del pH o humedad.";

//Video 1
videoLibrary.categories.data[categoryIndex]["videos"]=[];
videoLibrary.categories.data[categoryIndex]["videos"][0]={};
videoLibrary.categories.data[categoryIndex]["videos"][0].title="<span>CONOCE LOS BENEFICIOS DE</span><h2>LA TONIFICACIÓN</h2>";
videoLibrary.categories.data[categoryIndex]["videos"][0].videoUrl="https://cdn.shopify.com/videos/c/o/v/9ab2ce51cc05402eaa84efb2f8220887.mp4";
videoLibrary.categories.data[categoryIndex]["videos"][0].videoPoster="https://cdn.shopify.com/s/files/1/1131/8002/files/Tonico_Thumbnail.png?v=1678180402";
videoLibrary.categories.data[categoryIndex]["videos"][0].products=[];
videoLibrary.categories.data[categoryIndex]["videos"][0].products.push('/products/balancing-collagen-tonic');
videoLibrary.categories.data[categoryIndex]["videos"][0].products.push('/products/calming-collagen-tonic');
videoLibrary.categories.data[categoryIndex]["videos"][0].products.push('/products/revitalizing-collagen-tonic');

// Category 2
//Category page related data
categoryIndex++;
videoLibrary.categories.data[categoryIndex]={};
videoLibrary.categories.data[categoryIndex].title="ELIXIRES & SUEROS";
videoLibrary.categories.data[categoryIndex].coverImage="https://cdn.shopify.com/s/files/1/1131/8002/files/elisar_img.png?v=1678178328";
videoLibrary.categories.data[categoryIndex].description="Aprende sobre los tratamientos de Haute que son la Joya de la Corona: sueros y elixires.";

//Video 1
videoLibrary.categories.data[categoryIndex]["videos"]=[];
videoLibrary.categories.data[categoryIndex]["videos"][0]={};
videoLibrary.categories.data[categoryIndex]["videos"][0].title="<span>CONOCE LOS BENEFICIOS DE</span><h2>ELIXIRES Y SERUMS</h2>";
videoLibrary.categories.data[categoryIndex]["videos"][0].videoUrl="https://cdn.shopify.com/videos/c/o/v/5521ea24fdf84284b5a85da89172bc58.mp4";
videoLibrary.categories.data[categoryIndex]["videos"][0].videoPoster="https://cdn.shopify.com/s/files/1/1131/8002/files/Elixirs_Thumbnail.png?v=1678188234";
videoLibrary.categories.data[categoryIndex]["videos"][0].products=[];
videoLibrary.categories.data[categoryIndex]["videos"][0].products.push('/collections/post-medical-beauty');
videoLibrary.categories.data[categoryIndex]["videos"][0].products.push('/collections/elixir-treatments');


// Category 3
//Category page related data
categoryIndex++;
videoLibrary.categories.data[categoryIndex]={};
videoLibrary.categories.data[categoryIndex].title="OJOS & LABIOS";
videoLibrary.categories.data[categoryIndex].coverImage="https://cdn.shopify.com/s/files/1/1131/8002/files/EYES_LIPS_Category_Cover.png?v=1678178329";
videoLibrary.categories.data[categoryIndex].description="Nuestro co-fundador Diego, te enseña cómo proporcionar hidratación, fuerza y ​​restauración a estas áreas.";

//Video 1
videoLibrary.categories.data[categoryIndex]["videos"]=[];
videoLibrary.categories.data[categoryIndex]["videos"][0]={};
videoLibrary.categories.data[categoryIndex]["videos"][0].title="<span>APRENDE ACERCA DE</span><h2>CONTORNO DE OJOS</h2>";
videoLibrary.categories.data[categoryIndex]["videos"][0].videoUrl="https://cdn.shopify.com/videos/c/o/v/c3e143be400148f19a01ac156a20998d.mp4";
videoLibrary.categories.data[categoryIndex]["videos"][0].videoPoster="https://cdn.shopify.com/s/files/1/1131/8002/files/Upper_Lid_Thumbnail.png?v=1678188601";
videoLibrary.categories.data[categoryIndex]["videos"][0].products=[];
videoLibrary.categories.data[categoryIndex]["videos"][0].products.push('/products/eye-support-br-quench-restore-br-eye-serum-concentrate');
videoLibrary.categories.data[categoryIndex]["videos"][0].products.push('/products/eye-brighten-br-illuminate-lift-br-eye-serum-concentrate');
videoLibrary.categories.data[categoryIndex]["videos"][0].products.push('/products/upper-lid-and-contour-sublime-eye-balm');

// Category 4
//Category page related data
categoryIndex++;
videoLibrary.categories.data[categoryIndex]={};
videoLibrary.categories.data[categoryIndex].title="HIDRATANTES & SOL";
videoLibrary.categories.data[categoryIndex].coverImage="https://cdn.shopify.com/s/files/1/1131/8002/files/MOISTURIZERS_SUN_Category_Cover.png?v=1678178329";
videoLibrary.categories.data[categoryIndex].description="Tips profesionales de Diego para una hidratación suprema que te brindará  una piel verdaderamente sana y fresca, con un acabado natural.";

//Video 1
videoLibrary.categories.data[categoryIndex]["videos"]=[];
videoLibrary.categories.data[categoryIndex]["videos"][0]={};
videoLibrary.categories.data[categoryIndex]["videos"][0].title="<span>APRENDE SOBRE</span><h2>REAPLICACIÓN DE SPF</h2>";
videoLibrary.categories.data[categoryIndex]["videos"][0].videoUrl="https://cdn.shopify.com/videos/c/o/v/e5da5fd6f83443db9a1266329426a5b6.mp4";
videoLibrary.categories.data[categoryIndex]["videos"][0].videoPoster="https://cdn.shopify.com/s/files/1/1131/8002/files/Radiance_Thumbnail.png?v=1678188874";
videoLibrary.categories.data[categoryIndex]["videos"][0].products=[];
videoLibrary.categories.data[categoryIndex]["videos"][0].products.push('/products/radiance');







